var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["go-navbar", { notAllowClick: _vm.getIsLoadingUpdateLanguage }] },
    [
      _c("ul", { staticClass: "go-nav go-nav-primary" }, [
        _c(
          "li",
          {
            staticClass: "go-nav-list",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.handleHomeClickHome.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "router-link",
              {
                class: [
                  "go-nav-link",
                  { active: this.$route.name === "Home" },
                  {
                    notAllowClick:
                      (_vm.getIsWaitingResponse &&
                        _vm.$route.name === "Home") ||
                      _vm.isDisabledLink,
                  },
                ],
                attrs: { to: "/home?t=" + Date.now().toString() },
              },
              [
                _c("i", { staticClass: "go-icon-32 go-icon-home" }),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.$t("nav-bar.home"))),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "go-nav-list" },
          [
            _c(
              "router-link",
              {
                class: [
                  "go-nav-link",
                  { active: this.$route.name === "Discovery" },
                  {
                    notAllowClick:
                      (_vm.getIsWaitingResponse &&
                        _vm.$route.name === "Discovery") ||
                      _vm.isDisabledLink,
                  },
                ],
                attrs: { to: "/discovery" },
              },
              [
                _c("i", { staticClass: "go-icon-32 go-icon-discovery" }),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.$t("nav-bar.discovery"))),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "go-nav-list cursor-pointer",
            on: {
              click: function ($event) {
                return _vm.handleGoToUrlRequiredLogin(_vm.currentMyBriefingHref)
              },
            },
          },
          [
            _c(
              "div",
              {
                class: [
                  "go-nav-link",
                  {
                    active: _vm
                      .MY_BRIEFING_ROUTE_NAME_ACTIVE()
                      .includes(this.$route.name),
                  },
                  { notAllowClick: _vm.isDisabledLink },
                ],
              },
              [
                _c("i", { staticClass: "go-icon-32 go-icon-briefing-my" }),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [
                  _vm._v(_vm._s(_vm.$t("nav-bar.my-briefing"))),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("li", { staticClass: "go-nav-list cursor-pointer" }, [
          _c(
            "div",
            {
              class: [
                "go-nav-link",
                { notAllowClick: _vm.isDisabledLink },
                {
                  active: _vm
                    .SCRAP_AGENT_ROUTE_NAME_ACTIVE()
                    .includes(this.$route.name),
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.handleGoToUrlRequiredLogin("/scrap-agent")
                },
              },
            },
            [
              _c("i", { staticClass: "go-icon-32 go-icon-scrap-agent" }),
              _vm._v(" "),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("nav-bar.scrape-agent"))),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "go-nav go-nav-secondary" }, [
        _c("li", { staticClass: "go-nav-list" }, [
          _c(
            "a",
            {
              class: [
                "go-nav-link",
                {
                  active: _vm
                    .MY_CREATE_ROUTE_NAME_ACTIVE()
                    .includes(this.$route.name),
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.handleGoToUrlRequiredLogin("/my-create")
                },
              },
            },
            [
              _c("i", { staticClass: "go-icon-32 go-icon-my-creates" }),
              _vm._v(" "),
              _c("span", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("nav-bar.my-create"))),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.isAccountReady
          ? _c("li", { staticClass: "go-nav-list" }, [
              _c("div", { staticClass: "dropdown dropright" }, [
                _c(
                  "a",
                  {
                    staticClass: "go-nav-link",
                    attrs: {
                      "data-toggle": "dropdown",
                      "aria-expanded": "false",
                    },
                  },
                  [
                    _c("i", { staticClass: "go-user-thumb" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.account.imageUrl
                            ? _vm.account.imageUrl
                            : _vm.tempCurrentUserImageUri,
                          alt: "",
                        },
                        on: { error: _vm.onErrorImageAvatar },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [
                      _vm._v(_vm._s(_vm.shortenedLastName)),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    staticStyle: { width: "auto" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "dropdown-item-wrap" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            attrs: {
                              href: "#go-modal-event-plugin",
                              "data-toggle": "modal",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "go-icon-20 go-icon-download",
                            }),
                            _vm._v(
                              _vm._s(_vm.$t("nav-bar.download")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            class: { notAllowClick: _vm.isDisabledLink },
                            attrs: { to: "/my-page" },
                          },
                          [
                            _c(
                              "a",
                              {
                                class: [
                                  "dropdown-item",
                                  {
                                    active:
                                      this.$route.name ===
                                      "UserMyPageComponent",
                                  },
                                ],
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "go-icon-20 go-icon-user-setting",
                                }),
                                _vm._v(_vm._s(_vm.$t("nav-bar.my-page"))),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isGuest
                          ? _c(
                              "a",
                              {
                                staticClass: "dropdown-item",
                                attrs: {
                                  "data-toggle": "modal",
                                  "data-target": "#go-modal-logout",
                                },
                                on: { click: _vm.handleCloseModal },
                              },
                              [
                                _c("i", {
                                  staticClass: "go-icon-20 go-icon-logout",
                                }),
                                _vm._v(_vm._s(_vm.$t("nav-bar.logout"))),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("button", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        staticClass: "btn go-btn-icon",
        attrs: {
          id: "buttonCloseBackDrop",
          type: "button",
          "data-dismiss": "modal",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }